/* eslint-disable react/no-danger */
import React from 'react';

const DOMPurify = require('dompurify')(window);

export default function RenderHTML({ html }) {
  return (<div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} />);
}
